class Avatar {
    [x: string]: any;

    $onInit() {
        this.SIZE = {
            SMALL: {WIDTH: "32", FONT_SIZE: "24", CLASS_NAME: "avatar-small"},
            MEDIUM: {WIDTH: "32", FONT_SIZE: "18", CLASS_NAME: "avatar-medium"},
            XL: {FONT_SIZE: "17", CLASS_NAME: "avatar-xl"},
            LARGE: {WIDTH: "72", FONT_SIZE: "17", CLASS_NAME: "avatar-large"},
            ACCOUNT: {FONT_SIZE: "40", CLASS_NAME: "avatar-medium", FONT_WEIGHT: "600", CHAR_COUNT: "1", HEIGHT: "70", WIDTH: "70"},
        };
        this.DEFAUL_VALUES = {
            FONT_WEIGHT: "100",
            FONT_FAMILY: "Muli, sans-serif",
            CHAR_COUNT: "2",
            HEIGHT: "50",
            WIDTH: "50"
        };
        this.size = Object.assign(this.DEFAUL_VALUES, this.SIZE[this.avatarSize.toUpperCase()])
    }
}

export default {
    controller: Avatar,
    template: require('./avatar.html'),
    bindings: {avatarUrl: '<', fullName: '<', avatarSize: '@'}
}
